module.exports = __webpack_public_path__ + "img/tb.87b0ffa8.png";